import { Close, DescriptionOutlined } from '@mui/icons-material';
import { IconButton, Tooltip, useMediaQuery, Theme } from '@mui/material';
import Typography from 'component/MarketPlace/Typography';
import React from 'react';
import { truncateFileName } from '../utils';
import { StyledAttachment, StyledAttachmentName, StyledListAttachment } from './commentInput.style';
import { handleKeyPress } from 'utils/functions';

interface AttachmentListProps {
  attachments: File[];
  canDelete?: boolean;
  onRemove: (index: number) => void;
}

const AttachmentList = ({ attachments, canDelete, onRemove }: AttachmentListProps) => {
  const isSmDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <StyledListAttachment>
      {attachments.map((attachment, index) => (
        <StyledAttachment key={index} isMobile={isSmDown}>
          <DescriptionOutlined />

          <Tooltip title={attachment.name} arrow>
            <StyledAttachmentName>
              <Typography tabIndex={0} variant="body2" fontWeight={500}>
                {truncateFileName(attachment.name, canDelete ? 7 : 12)}
              </Typography>
            </StyledAttachmentName>
          </Tooltip>

          {canDelete && (
            <IconButton tabIndex={0} size="small" disableRipple onClick={() => onRemove(index)} aria-label="Remove Attachment" onKeyDown={(e: any) => handleKeyPress(e, 'Enter', () => onRemove(index))}>
              <Close />
            </IconButton>
          )}
        </StyledAttachment>
      ))}
    </StyledListAttachment>
  );
};

export default AttachmentList;
